import React, { useState } from 'react';
import api from '../../../services/api';
import QualificationOverlay from './QualificationOverlay';
import '../../../css/qualificationList.css';

const QualificationList = ({ qualifications, refreshQualificationsList }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleCount, setVisibleCount] = useState(20);
  const [success, setSuccess] = useState('');
  const [editingQualification, setEditingQualification] = useState(null);

  const filteredQualifications = qualifications.filter(q =>
    q.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleVisible = () => {
    if (visibleCount === filteredQualifications.length) {
      setVisibleCount(20);
    } else {
      setVisibleCount(filteredQualifications.length);
    }
  };

  const handleEdit = (id) => {
    const qual = qualifications.find(q => q.id === id);
    if (qual) {
      setEditingQualification(qual);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questa qualifica?")) return;
    try {
      await api.delete(`/qualifications/${id}`);
      setSuccess("Qualifica eliminata con successo!");
      setTimeout(() => setSuccess(""), 2000);
      if (refreshQualificationsList) refreshQualificationsList();
    } catch (error) {
      console.error("Errore nell'eliminazione della qualifica:", error);
    }
  };

  const closeOverlay = () => {
    setEditingQualification(null);
  };

  return (
    <div className="qualification-list">
      <div className="qualification-list-search">
        <input
          type="text"
          placeholder="Cerca qualifica..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="qualification-search"
        />
      </div>
      <div className="qualification-list-items">
        {success && <p className="success">{success}</p>}
        {filteredQualifications.slice(0, visibleCount).map(qual => (
          <div key={qual.id} className="qualification-card">
            <h3 className="qualification-title">{qual.name}</h3>
            {qual.description && (
              <p className="qualification-description">{qual.description}</p>
            )}
            <div className="qualification-actions">
              <button onClick={() => handleEdit(qual.id)}>Modifica</button>
              <button onClick={() => handleDelete(qual.id)}>Elimina</button>
            </div>
          </div>
        ))}
      </div>
      {filteredQualifications.length > 20 && (
        <button onClick={toggleVisible} className="redirect-btn">
          {visibleCount === filteredQualifications.length ? 'Mostra meno' : 'Mostra altro'}
        </button>
      )}
      {editingQualification && (
        <QualificationOverlay
          qualification={editingQualification}
          onClose={closeOverlay}
          onUpdate={refreshQualificationsList}
        />
      )}
    </div>
  );
};

export default QualificationList;
